<template>
  <div class="customerSelect" style="width: 800px;">
    <div class="upload">
      <div class="input_box">
        <!-- <div class="sel">
          <label>客户编码 :&nbsp;</label>
          <Select id="customerCode" v-model="selectData" @on-change="accessorySelect" transfer clearable filterable>
            <Option v-for="(item , index) in uploadItem" :key="index" :value="item.id" :label="item.name">{{item.code}}:{{item.name}}</Option>
          </Select>
        </div> -->
        <div class="input">
          <label>客户编码 :&nbsp;</label>
          <input id="customer_code" v-model="customerCode"  />
          <label>客户名称 :&nbsp;</label>
          <input id="customer_name" v-model="customerName"  />

    
        </div>
        <div class="input">
          <label>集团编码 :&nbsp;</label>
          <input id="group_code" v-model="groupCode"   />
          <label>集团名称 :&nbsp;</label>
          <input id="group_name" v-model="groupName"   />
        </div>
      </div>
    </div>
    <div class="button_box">
        <Button class="sav-btn" @click="syncItem">同步</Button>
        <Button class="sav-btn" @click.stop="getTableData">查询</Button>
        <Button class="sav-btn" @click="refresh">重置</Button>
      </div>
    <div class="pageNation">
      <Page :total="page.total" show-sizer :page-size-opts="page.pageSizeOpts" :current="page.current" :page-size="page.pageSize" 
          @on-change="pageChange" @on-page-size-change="pageSizeChange" />
    </div>
    <div class="table">
      <Table :columns="tableConfig.columns" :data="tableConfig.data" @on-selection-change="onSelectChange"></Table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
const mapping = {
  "CL_C_CUST_OPEN": { //客户开户申请
    tableName: "CL_C_CUST_OPEN_ADDR_ITEM",
    tableId: 249130070,
    refcolId: 1700802811,
  },
  "CL_C_CUST_OPEN_EXPAND": { //客户拓展申请
    tableName: "CL_C_CUST_OPEN_ADDR_ITEM",
    tableId: 249130070,
    refcolId: 1700802811,
  },
  "CP_C_CUSTOMER_NEW_2": { //客户档案-销省子区
    tableName: "CP_C_CUSTOMER_ADDR_ITEM",
    tableId: 249130076,
    refcolId: 1700802940,
  },
  "CP_C_CUSTOMER_NEW_3": { //客户档案-总部渠道
    tableName: "CP_C_CUSTOMER_ADDR_ITEM",
    tableId: 249130076,
    refcolId: 1700802940,
  },
  "CP_C_CUSTOMER_NEW_5": { //客户档案-物流人员
    tableName: "CP_C_CUSTOMER_ADDR_ITEM",
    tableId: 249130076,
    refcolId: 1700802940,
  }
}
export default {
  name: 'customerSelect',
  data() {
    return {
      tableName: "", // 主表表名
      tableId: "", // 主表ID
      itemId: "", // 子表ID
      customerCode: "",
      customerName: "",
      groupCode: "",
      groupName: "",
      customerId: "",
      page: {
        total: 1,
        start: 0,
        current: 1,
        pageSize: 10,
        pageSizeOpts: [1, 10, 20, 30, 50]
      },
      uploadItem: [],
      files: [],
      selectData: '',
      tableConfig: {
        width: {
          table_width: '100%',
          head_width: 100,
        },
        columns: [
          {
            title: 'ID',
            key: 'ID',
            type: 'selection',
            name: 'ID'
          },
          {
            title: '客户编码',
            key: 'CUSTOMER_CODE',
          },
          {
            title: '客户名称',
            key: 'CUSTOMER_NAME',
          },
          {
            title: '联系人',
            key: 'CONTACTS',
          },
          {
            title: '收货省份',
            key: 'PROVICE',
          },
          {
            title: '收货地级市',
            key: 'CITY',
          },
          {
            title: '收货区县级市',
            key: 'COUNTY',
          },
          {
            title: '详细地址（不含省市区）',
            key: 'DETAIL_ADDR',
          },
          {
            title: '地址',
            key: 'ADDRESS',
          },
        ],
        data: []
      },
      onSelectChangeData: []
    }
  },
  created() {
    const { tableName, tableId, itemId } = this.$router.currentRoute.params;
    this.tableName = tableName;
    this.tableId = tableId;
    this.itemId = itemId;
    this.initData();
    //this.custList();
  },
  activated() {
    //this.refresh();
  },
  destroyed() {
    
  },
  methods: {
    refresh() {  //刷新
      console.log("refresh");
      this.customerName = '';
      this.customerCode = '';
      this.groupCode = '';
      this.groupName = '';
      this.page.current = 1
      this.$nextTick(() => {
        this.files = [];
        this.onSelectChangeData = []
      })
      this.getTableData();
    },
    initData() {
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      const params = {
        table: this.tableName,
        tableId: this.tableId,
        objid: this.itemId,
      };
      axios({
        url: '/p/cs/getGroupCustomer',
        method: 'post',
        data: params
      }).then(res => {
        this.groupCode = res.data.code;
        this.groupName = res.data.name;
        this.getTableData();
      });
    },

    custList() {
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      const params = {
        table: this.tableName,
        tableId: this.tableId,
        objid: this.itemId,
      };
      axios({
        url: '/p/cs/groupCustomerSelect',
        method: 'post',
        data: params
      }).then(res => {
        this.uploadItem = res.data;
      });
    },
   
    accessorySelect(value,label){
      this.customerId = value;
      this.customerName = label.query;
    },

    getTableData() {
      var params = {
        "ecode": this.customerCode,
        "ename": this.customerName,
        "groupCode": this.groupCode,
        "groupName": this.groupName,
        "startindex": this.page.pageSize * (this.page.current - 1),
        "range": this.page.pageSize
      }
      this.$network.post("/p/cs/getGroupAddressList", params).then((res) => {
        console.log(res);
        if (res.data.data.code == 0) {
          var datas = res.data.data.data;
          this.page.total = datas.totalRowCount; //总条数
          this.page.start = datas.start; //开始条数
          //this.page.pageSize = datas.rowCount; //每页条数
          //this.page.pageSizeOpts = datas.selectrange;
          this.renderColumn(this.tableConfig.columns);
          let tempTableData = datas.row.map(item => {
            let obj = {};
            for (let key in item) {
              obj[key] = item[key].val;
            }
            return obj;
          });
          this.tableConfig.data = tempTableData
        }
      });
    },
    
    renderColumn(column) {
      column.forEach(item => {
        if (item.key == 'TYPE') {
          item['render'] = (h, params) => {
            console.log('1');
            if (!params.row.TYPE) return
            let str = JSON.parse(params.row.TYPE).map(item => {
              return `【${item.name}】`
            })
            return h('div', {
              style: {
                position: 'relative'
              }
            },
            [
              h('span', {
              }, str),
              h('Poptip', {
                props: {
                  trigger: 'click',
                  transfer: true,
                  content: 'content'
                },
                scopedSlots: {
                  default: () => h('div', {
                    style: {
                      'padding-left': '10px',
                      'padding-right': '10px',
                    },
                    domProps: {
                      innerHTML: '<i class="iconfont iconbj_listedit" style="color: #2D8CF0; font-size: 16px"></i>'
                    },
                  }),
                  content: () => h('uploadDalog', {
                    props: {
                      uploadData: params.row
                    },
                    on: {
                      'refresh': () => {
                        console.log('2');
                        this.refresh();
                      }
                    }
                  })
                }
              })
            ])
          }
        }
      })
    },
    onSelectChange(sel) {
      this.onSelectChangeData = sel;
    },

    syncItem() {
      if (this.onSelectChangeData.length == 0) {
        this.$Message.warning('请先选择需要同步的客户地址信息！');
        return;
      }
      if (this.onSelectChangeData.length > 1) {
        this.$Message.warning('只能选择一个同步的客户地址信息！');
        return;
      }
      this.$Modal.fcWarning({
        title: '提示',
        content: '确认执行同步?',
        showCancel: true,
        onOk: () => {
          const { tableName, itemId } = this.$router.currentRoute.params;
          const params = {
            table: mapping[tableName].tableName,
            objid: this.itemId,
            selectId: this.onSelectChangeData[0].ID,
          };
          this.$network.post("/p/cs/syncGroupCustomer", params).then((res) => {
            if (res.data.data.code == 0) {
              this.$Modal.fcSuccess({
                title: "成功",
                content: "同步成功",
              });
              this.$emit("closeActionDialog", true); 
            } else {
              this.$Modal.fcError({
                title: "失败",
                content: res.data.data.message,
              });
              this.$emit("closeActionDialog", true); 
            }
          });

        }
      })
    },

    pageChange(val) {
      console.log("pageChange");
      this.page.current = val;
      this.getTableData();
    },
    pageSizeChange(val) {
      console.log("pageSizeChange");
      this.page.pageSize = val;
      this.getTableData();
    }
  }
}
</script>

<style lang="less">
.customerSelect {
  height: 500px;
  .upload {
    display: flex;
    background: #f8f8f8;
    .sel,
    .upl {
      white-space: nowrap;
      line-height: 26px;
      display: flex;
      width: 200px;
      margin-left: 50px;
      margin-top: 5px;
      margin-bottom: 5px;
      label:before {
        content: "*";
        color: red;
        margin-right: 2px;
      }
    }
    .upl {
      margin-left: 100px;
      .uplFile {
        cursor: pointer;
        color: #0f8ee9;
      }
    }
    .sel {
      .icon {
        color: red;
        font-size: 12px;
      }
    }
  }
  .pageNation {
    margin: 8px 0;
    display: flex;
    .button {
      color: #0f8ee9;
      margin-top: 9px;
      cursor: pointer;
    }
  }
  .ark-tooltip-popper .ark-tooltip-inner{
    line-height: 16px !important;
  }
  .pop-btn {
    display: flex;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-left: 10px;
    }
  }
}
</style>